export const MenuItems = [
    {
        title: 'HOME',
        url: '',
        cName: 'nav-links'
    },
    {
        title: 'RESUME',
        url: 'resume',
        cName: 'nav-links'
    },
    {
        title: 'PROJECTS',
        url: 'projects',
        cName: 'nav-links'
    },
    {
        title: 'CONTACT',
        url: 'contact',
        cName: 'nav-links'
    }
]